import { ORGANIZATION_ROUTES, USERS_ROUTES } from '@routes';
import BreadcrumbLink from '@components/layout/Breadcrumbs/BreadcrumbLink';

export const CommonBreadcrumbs = {
  Home: () => <BreadcrumbLink to={`${process.env.VITE_BRIGHTPATH_HOME_PAGE_URL}`}>Home</BreadcrumbLink>,

  Organizations: () => <BreadcrumbLink to={ORGANIZATION_ROUTES.ORGANIZATIONS}>Organizations</BreadcrumbLink>,

  TenantName: ({ tenantName, tenantId }: { tenantName: string; tenantId: string }) => (
    <BreadcrumbLink to={`${ORGANIZATION_ROUTES.ORGANIZATIONS}/${tenantId || window.location.pathname.split('/')[2]}`}>
      {tenantName || 'Details'}
    </BreadcrumbLink>
  ),

  Users: () => <BreadcrumbLink to={USERS_ROUTES.USERS}>Users</BreadcrumbLink>,
};

export const commonTenantBreadCrumbs = (tenantId: string, tenantName: string) => [
  <CommonBreadcrumbs.Home />,
  <CommonBreadcrumbs.Organizations />,
  <CommonBreadcrumbs.TenantName tenantId={tenantId} tenantName={tenantName} />,
];
